"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Thrown when attempting to change an email to one that already exists
 */
class EmailAlreadyExistsError extends client_library_1.ExtendableError {
    constructor(email) {
        super(`Email ${email} already exists`);
        this.email = email;
    }
}
exports.default = EmailAlreadyExistsError;
